
import { TransferAssetEntityDecorator } from './transfer-asset.decorator';
import { TransferAsset } from './transfer-asset.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class TransferAssetTypeInfoBase implements CrudTypeInfo<TransferAsset, number> {
  name = 'Transfer Asset';
  entityDecorator = new TransferAssetEntityDecorator();
  
  createAuthorities = ['WRITE_TRANSFER_ASSET'];
  editAuthorities = ['WRITE_TRANSFER_ASSET'];
  deleteAuthorities = ['WRITE_TRANSFER_ASSET'];
  viewAuthorities = ['READ_TRANSFER_ASSET'];
  
  searchRouteBase = ['/transferasset/search'];
  createRouteBase = ['/transferasset/create'];
  editRouteBase = ['/transferasset/edit'];
  viewRouteBase = ['/transferasset/view'];
  
  description(item: TransferAsset): string {
    return '' +  item.transferAssetId;
  }
}



